import cn from "classnames"
import { ReactNode } from "react"

type ContentLayoutProps = {
  classNames?: string;
  children: ReactNode;
};

export default function ContentLayout({ children, classNames } : ContentLayoutProps) {
  return <section className={cn("grid grid-cols-12-gap tablet:grid-cols-8-gap mobile:grid-cols-4-gap gap-grid-gap max-w-d-base mx-auto w-d-base:px-6", classNames)}>
    { children }
  </section>
}